import { InfoCard, InfoCardMedia, InfoCardTitle } from "./styles";
import ImageContainer from "@components/imageContainer";
import { PrimaryButton } from "@acko-tech/building-blocks.ui.button";

type UnableToFindBrandCardProps = {
  imgSrc?: string;
  alt?: string;
  height?: number;
  width?: number;
  title?: string;
  buttonLabel?: string;
  isFullWidth?: boolean;
  onClick?: () => void;
};

const UnableToFindBrandCard = ({
  imgSrc,
  alt,
  height,
  width,
  title,
  buttonLabel,
  isFullWidth,
  onClick
}: UnableToFindBrandCardProps) => {
  return (
    <InfoCard>
      <InfoCardMedia>
        <ImageContainer
          imgSrc={imgSrc}
          alt={alt}
          height={height}
          width={width}
          isResolvePath={true}
        />
      </InfoCardMedia>
      <InfoCardTitle>{title}</InfoCardTitle>
      <PrimaryButton isFullWidth={isFullWidth} onClick={onClick}>
        {buttonLabel}
      </PrimaryButton>
    </InfoCard>
  );
};
export default UnableToFindBrandCard;
